import { useNamespacedStore } from '~/compositions/store'
import {
  USER_AGENT_NS,
  UserAgentState
} from '~/store/modules/shared/userAgent/state'
import { computed } from '~/utils/nuxt3-migration'

export function useUserAgent() {
  const { getters: userAgentGetters } = useNamespacedStore<UserAgentState>(
    USER_AGENT_NS
  )

  const isPc = computed(() => userAgentGetters('isPc'))

  const isMobile = computed(() => userAgentGetters('isMobile'))

  const isTablet = computed(() => userAgentGetters('isTablet'))

  function isAutomatedBrowser() {
    if (process.server) {
      return false
    }

    // navigator.webdriver is true in most modern headless browsers
    if (navigator.webdriver) {
      return true
    }

    const ua = navigator.userAgent.toLowerCase()

    // Headless browser signatures in the user-agent
    const automatedUaPatterns = [
      'headlesschrome',
      'headless',
      'puppeteer',
      'playwright',
      'node.js',
      'nodejs'
    ]

    return automatedUaPatterns.some(p => ua.includes(p))
  }

  return { isPc, isMobile, isTablet, isAutomatedBrowser }
}
